<template>
    <div class="invoice">
        <div class="container order-content">
            <div class="manage-main">
                <div class="rule" style="display: flex;background: #fff;">
                    <Menu></Menu>
                    <div class="manage-right">
                        <div class="right-top" style="margin-bottom: 30px;">
                        <div class="right-title">发票列表</div>
                        <div class="manage-invoice-hotel">
                        	<div class="input-box">
                                <div class="input-label">结算类型：</div>
                                <div class="select-box">
                                    <select v-model="SettlementType">
                                        <option value="0">单结</option>
                                        <option value="1">周期结</option>
                                    </select>
                                </div>
                                <div class="input-label">开票类型：</div>
                                <div class="select-box">
                                    <select v-model="InvoiceType">
                                        <option value="0">电子发票</option>
                                    </select>
                                </div>
                            </div>
                            <div class="search" @click="searchInvoice">搜索</div>
                        </div>
                        </div>
                        <div class="invoice-table-box">
                            <table class="invoice-table">
                                <thead>
                                <tr>
                                    <td width="55px">结算类型</td>
                                    <td width="55px">账单金额</td>
                                    <td width="120px">类型<br/>名称</td>
                                    <td width="55px">发票种类</td>
                                    <td width="55px">开票状态</td>
                                    <td width="55px">开票时间</td>
                                    <td width="55px">发票详情</td>
                                </tr>
                                </thead>
                                <tbody v-if="!isLoading && invoiceList.length > 0">
                                <tr v-for="item,index in invoiceList" :key="item.OrderOrBillNo">
                                    <td width="55px">{{item.SettlementType}}</td>
                                    <td width="55px">{{item.Accounts}}{{item.Currency}}</td>
                                    <td width="120px">{{item.InvoiceTitle}}<br/>{{item.InvoiceName}}</td>
                                    <td width="55px">{{item.InvoiceKind}}</td>
                                    <td width="55px">{{item.InvoiceStatus}}</td>
                                    <td width="55px">{{item.CreateDateStr}}</td>
                                    <td width="55px" class="view" @click="goDetail(item.OrderOrBillNo)">查看详情</td>
                                </tr>
                                </tbody>
                                <tbody v-else>
                                <tr>
                                    <td align="center" style="vertical-align: middle" colspan="9">
                                        <div v-if="isLoading">
                                            <Loading :isLoading="isLoading"></Loading>
                                        </div>
                                        <div v-else>{{noneDataMsg}}</div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                           <div class="Page">
                                <span @click="handlePrev" class="PageBtn">上一页</span>
                                <span class="PageNumber">第{{curPage}}页/共{{allPage}}页</span>
                                <span @click="handleNext" class="PageBtn">下一页</span>
                           </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Menu from './../../common/cmpnt/menu/Menu'
    import Loading from './../../common/cmpnt/Loading/Loading.vue'//缓冲

    export default {
        name: "invoice",
        components: {
            Menu,
            Loading

        },
        data() {
            return {
                SettlementType: 0,
                InvoiceType: 0,
                invoiceList: [],
                isLoading:true,
                noneDataMsg:'',
                //分页
                allPage: '', //总页数
                curPage: 1, //当前页码
                pageSize: 8, //每页展示数量
            }
        },
        watch:{
            SettlementType(){
                this.noneDataMsg=''
            }
        },
        mounted() {
            document.title = '发票管理'
            this.searchInvoice()
        },
        methods: {

            handlePrev(){
                if(this.curPage>1){
                    this.curPage--;
                    this.searchInvoice()
                }else {
                     this.error({title:'提示',content:'当前为最前页'});
                }
            },


            handleNext(){
                if(this.curPage<this.allPage){
                    this.curPage++;
                    this.searchInvoice()
                }else {
                     this.error({title:'提示',content:'当前为最后页'});
                }
            },

            

            goDetail(item){
                let data='';
                if(item.indexOf(",")==-1){
                    data=item
                }else{
                    data=item.split(",")[0]
                }
                let routeData= this.$router.resolve({
                    path: '/invoiceDetails/'+data,
                    // query: {id:96}
                    // params: { orderNO: id }
                })
                window.open(routeData.href, '_blank')
            },
            searchInvoice () {
                let that = this
                let param = {
                    PageIndex: this.curPage,
                    PageSize: this.pageSize,
                    SettlementType: this.SettlementType,
                    InvoiceType: this.InvoiceType
                }
                that.isLoading = true
                //  发请求
                that.postRequest({
                    //  请求的url   api文件里面写的
                    url:that.Api.InvoiceSearchInvoices,
                    params:param
                }).then(res => {
                    that.invoiceList = []
                    if(res.IsSuccess){
                        //  如果成功了
                        that.isLoading = false
                        that.invoiceList = res.Result
                        that.allPage = Math.ceil(res.Total/that.pageSize)
                        if(!res.Total){
                            that.noneDataMsg='暂无数据...'
                        }else{
                            that.noneDataMsg=''
                        }
                        that.$nextTick(() => {
                            if(localStorage.getItem('lang')=='t'){
                                that.$zh_tran(localStorage.getItem('lang'))
                            }        
                        })
                    }else{
                        //  如果失败了
                        this.error({title:'提示',content:res.Msg||'保存失败'});
                    }
                });
            }
        }
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/invoice/hotel.vue